import Axios from "axios";
import config from "../config";

export const API_URL = config.API_BASE_URL;
// export const API_URL = "https://preprod-api.chaabicash.ma/api";
// export const API_URL = "https://m2t-chaabicash-api.dev.x-hub.io/api";

export const http = Axios.create({
  baseURL: API_URL,
});

// eslint-disable-next-line consistent-return
http.interceptors.response.use(undefined, error => {
  if (error?.response?.status === 401) {
    window.location.reload();
  } else {
    return Promise.reject(error);
  }
});
